import actions from './constants';

export const updateFullscreen = () => ({
  type: actions.UPDATE_FULL_SCREEN,
});

export const updateActions = (name, category, code, url) => ({
  type: actions.UPDATE_ACTIONS,
  name,
  category,
  code,
  url,
});

export const updateTabs = (tabs) => ({
  type: actions.UPDATE_TABS,
  tabs,
});

export const updateTitle = (title) => ({
  type: actions.UPDATE_TITLE,
  title,
});
